var map = {
	"./browser__chrome.png": 1886,
	"./browser__edge.png": 3532,
	"./browser__firefox.png": 6666,
	"images/browser__chrome.png": 1886,
	"images/browser__edge.png": 3532,
	"images/browser__firefox.png": 6666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2376;